import { AdvertiseData } from '../../containers/advertising/advertising.types';
import { API_URL } from '../config';

export const ADVERTISE_DATA: AdvertiseData = {
  advertisingCountries: {
    IN: {
      FOREX: {
        accountType: 'INDIVIDUAL',
        userStatus: 'APPROVED',
        main_content: {
          heading: 'Purchase foreign currencies in cash or card'
        },
        button: {
          action: 'POPUP',
          btn_content: {
            content: 'Click here'
          },
          className: 'advertise-btn',
          popup_content: {
            heading:
              'We now offer foreign currencies in the form of Forex cards or cash to be picked up or delivered to your doorstep.',
            content: ['Click below and our team will contact you shortly.'],
            buttons: [
              {
                action: 'API_CALL',
                btn_content: {
                  content: 'Yes, please'
                },
                className: 'default-btn',
                api_params: {
                  url: `${API_URL}/remitter/consent`,
                  method: 'post',
                  data: {
                    user_consent: true,
                    brand: 'FOREX'
                  }
                },
                on_success: 'POPUP',
                popup_content: {
                  heading: 'Thank you for your interest in our Forex services. ',
                  content: ['We will contact you shortly.'],
                  buttons: [
                    {
                      action: 'CLOSE',
                      className: 'default-btn',
                      deleteContent: true,
                      btn_content: {
                        content: 'Ok'
                      }
                    }
                  ]
                }
              },
              {
                action: 'API_CALL',
                api_params: {
                  url: `${API_URL}/remitter/consent`,
                  method: 'post',
                  data: {
                    user_consent: false,
                    brand: 'FOREX'
                  }
                },
                on_success: 'CLOSE',
                className: 'default-btn',
                deleteContent: true,
                btn_content: {
                  content: 'No, thanks'
                }
              }
            ]
          }
        }
      }
    }
  }
};
